import { Component, Input } from '@angular/core'
import {
    formatJobResultSelections,
    JobResultSelectionRef,
    RecurrentNeighborhoodsResult,
} from '../../../state/case/case.state'
import { HttpErrorResponse } from '@angular/common/http'
import { DownloadService } from '../../../shared/services/download.service'
import { ToasterService } from '../../../shared/services/toaster.service'

@Component({
    selector: 'app-recurrent-neighborhoods-result-content',
    templateUrl: './recurrent-neighborhoods-result-content.component.html',
    styleUrls: ['./recurrent-neighborhoods-result-content.component.scss'],
})
export class RecurrentNeighborhoodsResultContent {
    @Input()
    rcnEntry: RecurrentNeighborhoodsResult

    constructor(private downloadService: DownloadService, private toaster: ToasterService) {}

    detailsVisible = false

    formatSelections(selections: JobResultSelectionRef[] | undefined): string {
        return formatJobResultSelections(selections)
    }

    toggleDetails(): void {
        this.detailsVisible = !this.detailsVisible
    }

    downloadData(): void {
        this.downloadService.downloadRecurrentNeighborhood(this.rcnEntry.download_File).subscribe({
            error: (err: HttpErrorResponse) => {
                this.toaster.httpError(
                    err,
                    `Failed to download recurrent neighborhood ${this.rcnEntry.name}.`
                )
            },
        })
    }
}
